import * as React from "react";
import {useContext} from "react";
import {DispatchContext} from "App";
import Dokumentliste from "components/Dokumentliste";
import Vadis from "services/vadisKontrollrapportService";
import ListeMedBeskrivelse from "components/ListeMedBeskrivelse";
import {useApptekster} from "../contexts/ApptekstContext";
import {SVVButton} from "@komponentkassen/svv-button";
import { Kontrollrapport } from '../types/generated';

type Props = {
    kontrollrapport: Kontrollrapport
}

function Kontrollrapportvisning({kontrollrapport: {referansenummer, kjoretoy, forere, passasjer, dokumenter}}: Props) {
    const t = useApptekster();
    const dispatch = useContext(DispatchContext);

    function loggUtBruker() {
        Vadis.loggUt().finally(() => {
            dispatch({type: "LOGG_UT"});
        });
    }

    return (
        <>
            <h2 className="normaltittel" data-hj-suppress>
                {`${t("vadis-kontrollrapport-rapport.tittel")} ${referansenummer}`}
            </h2>
            <ListeMedBeskrivelse beskrivelse={t("vadis-kontrollrapport-rapport.passasjerer")}
                                 elementer={passasjer}
                                 skalVises={passasjer.length > 0} />
            <ListeMedBeskrivelse beskrivelse={t("vadis-kontrollrapport-rapport.forere")}
                                 elementer={forere}
                                 skalVises={forere.length > 0} />
            <ListeMedBeskrivelse beskrivelse={t("vadis-kontrollrapport-rapport.kjoretoy")}
                                 elementer={kjoretoy}
                                 skalVises={kjoretoy.length > 0} />
            <Dokumentliste dokumenter={dokumenter} overskrift={t("vadis-kontrollrapport-rapport.dokumenter")}/>
            <SVVButton onClick={loggUtBruker}>{t("vadis-kontrollrapport-rapport.logg-ut")}</SVVButton>
        </>
    )
}

export default Kontrollrapportvisning;
